import React, { useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import './HolidayPackageCarousel.css'

// Shared by the Travel Packages home page's Featured / Domestic /
// International rows. Loop + autoplay only kick in once there are enough
// slides to fill the widest breakpoint — Swiper's loop mode duplicates
// slides and looks broken with fewer packages than visible columns.
const HolidayPackageCarousel = ({ title, subtitle, packages, onSelect, onViewAll }) => {
    const prevRef = useRef(null)
    const nextRef = useRef(null)

    if (!packages.length) return null

    const canLoop = packages.length > 3

    const bindNav = (swiper) => {
        swiper.params.navigation = { ...swiper.params.navigation, prevEl: prevRef.current, nextEl: nextRef.current }
        swiper.navigation.init()
        swiper.navigation.update()
    }

    return (
        <section className='pkgCarousel'>
            <div className='container'>
                <div className='pkgCarousel__head'>
                    <div>
                        <div className='pkgCarousel__title'>{title}</div>
                        {subtitle && <div className='pkgCarousel__subtitle'>{subtitle}</div>}
                    </div>
                    <div className='pkgCarousel__controls'>
                        {onViewAll && (
                            <button type='button' className='pkgCarousel__viewAll' onClick={onViewAll}>View All</button>
                        )}
                        <button type='button' className='pkgCarousel__nav' aria-label='Previous' ref={prevRef}>&#8249;</button>
                        <button type='button' className='pkgCarousel__nav' aria-label='Next' ref={nextRef}>&#8250;</button>
                    </div>
                </div>

                <Swiper
                    className='pkgCarousel__swiper'
                    modules={[Navigation, Autoplay, Pagination]}
                    spaceBetween={22}
                    slidesPerView={1.15}
                    loop={canLoop}
                    grabCursor
                    pagination={{ clickable: true }}
                    autoplay={canLoop ? { delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: true } : false}
                    onSwiper={bindNav}
                    breakpoints={{ 576: { slidesPerView: 2 }, 992: { slidesPerView: 3 } }}
                >
                    {packages.map((pkg) => (
                        <SwiperSlide key={pkg.id}>
                            <button type='button' className='pkgCard' onClick={() => onSelect(pkg)}>
                                <div className='pkgCard__media'>
                                    <img src={pkg.image} alt={pkg.title} />
                                    <div className='pkgCard__shade' />
                                    {pkg.badge && <span className='pkgCard__badge'>★ {pkg.badge}</span>}
                                    <span className='pkgCard__duration'>{pkg.nights}N / {pkg.days}D</span>
                                    <div className='pkgCard__overlayInfo'>
                                        <span className='pkgCard__type'>{pkg.destinationType}</span>
                                        <span className='pkgCard__rating'>★ {pkg.rating} <em>({pkg.reviewsCount})</em></span>
                                    </div>
                                </div>
                                <div className='pkgCard__body'>
                                    <div className='pkgCard__title'>{pkg.title}</div>
                                    <div className='pkgCard__meta'>{pkg.cityLine} · {pkg.country}</div>
                                    <div className='pkgCard__tags'>
                                        {pkg.tags.slice(0, 3).map((tag) => <span key={tag}>{tag}</span>)}
                                    </div>
                                    <div className='pkgCard__bottom'>
                                        <div>
                                            <div className='pkgCard__oldRow'>
                                                <span className='pkgCard__old'>₹{pkg.oldPrice.toLocaleString('en-IN')}</span>
                                                <span className='pkgCard__off'>{pkg.discountLabel}</span>
                                            </div>
                                            <div className='pkgCard__price'>₹{pkg.price.toLocaleString('en-IN')} <small>/ person</small></div>
                                        </div>
                                        <span className='pkgCard__cta'>Explore &rarr;</span>
                                    </div>
                                </div>
                            </button>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    )
}

export default HolidayPackageCarousel
